import React from "react";
import Select, { SelectOption } from "@amzn/meridian/select";
import { GroundTruthUploadFileOption } from "src/store/modelLifeCycleSlice";
import { setSelectedUploadFileValues } from "src/store/modelLifeCycleSlice";
import { useAppDispatch, useAppSelector } from "src/store/store";
import { isAdminUser } from "src/utils/permissionUtil";

const uploadFileOptions: GroundTruthUploadFileOption[] = [
  {
    id: "SOURCE_ID_AND_TEXT",
    value: "source id and text only",
    label: "Source id and source text only",
  },
  {
    id: "CONFIRMED_ANSWER",
    value: "confirmed answer",
    label: "With reviewed field inputs",
  },
  {
    id: "OVERWRITE_CONFIRMED_ANSWER",
    value: "overwrite confirmed answer",
    label: "Overwrite confirmed answer",
  },
  {
    id: "LLM_ANSWER",
    value: "llm answer",
    label: "With pre labeled LLM Answer",
  },
];

const GroundTruthUploadFileSelection = () => {
  const dispatch = useAppDispatch();
  const { selectedUploadFileValues } = useAppSelector((state) => state.modelLifeCycleSlice);

  const { ldap } = useAppSelector((state) => state.user);

  return (
    <Select
      label="upload ground truth data to improve model accuracy"
      value={selectedUploadFileValues}
      onChange={(e) => dispatch(setSelectedUploadFileValues(e))}
      width={400}
    >
      {uploadFileOptions.map((uploadFileOption) => {
        if (["overwrite confirmed answer", "llm answer"].includes(uploadFileOption.value)) {
          return (
            isAdminUser(ldap) && (
              <SelectOption
                key={uploadFileOption.id}
                value={uploadFileOption.value}
                label={uploadFileOption.label}
              ></SelectOption>
            )
          );
        }

        return (
          <SelectOption
            key={uploadFileOption.id}
            value={uploadFileOption.value}
            label={uploadFileOption.label}
          ></SelectOption>
        );
      })}
    </Select>
  );
};

export default GroundTruthUploadFileSelection;
